'use strict';

module.exports = require('react/lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// ./~/@allenfang/react-toastr/~/react-dom/index.js
// module id = 257
// module chunks = 0